<template>
	<v-dialog v-model="dialog" persistent no-click-animation scrollable max-width="500px">
		<v-card>
			<v-card-title>
				授权申请
				<v-spacer />
				<v-btn class="mx-0" icon @click="close">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-divider />
			<v-card-text class="pt-4">
				<v-list-item class="rounded mb-4 pa-3" style="border: 1px dashed #99999952">
					<v-list-item-avatar class="rounded" color="blue-grey lighten-5" size="56">
						<v-icon color="blue" size="36">mdi-poker-chip</v-icon>
					</v-list-item-avatar>
					<v-list-item-content>
						<v-list-item-title class="title font-weight-regular mb-1">{{ entity.uniName }}</v-list-item-title>
						<v-list-item-subtitle style="line-height: unset">{{ entity.uniCode }}</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>
				<v-form class="mt-1" ref="entity" v-model="valid" :model="entity">
					<vtk-area-tree v-model="entity.areaCode" :rules="[(v) => !!v || '区域限制不能为空!']" label="区域限制" selectable :minLeve="2" :maxLeve="6" />
					<v-menu ref="menu" v-model="menu" :close-on-content-click="false" :return-value.sync="dates" transition="scale-transition" nudge-top="24" offset-y min-width="auto">
						<template v-slot:activator="{ on, attrs }">
							<v-text-field v-model="entity.time" readonly v-bind="attrs" v-on="on" dense outlined label="时间限制" :rules="[(v) => !!v || '请选择时间区间!']" clearable></v-text-field>
						</template>
						<v-date-picker v-model="dates" range no-title scrollable :min="new Date() | date('yyyy-MM-dd')">
							<v-spacer></v-spacer>
							<v-btn text color="primary" @click="menu = false">返回</v-btn>
							<v-btn text color="primary" @click="timeSave">确定</v-btn>
						</v-date-picker>
					</v-menu>

					<v-textarea v-model="entity.addr" dense outlined label="地址限制" :rules="[(v) => /^\d*[.,\*\d]*$/.test(v) || '地址限制不能为空!']" hint="多地址逗号(,)分隔" clearable></v-textarea>
					<v-text-field v-model="entity.nums" dense outlined label="每日限量" :rules="[(v) => !!v || '每日限量不能为空!']" type="number" clearable></v-text-field>
					<v-card-title class="pt-0 pl-0 pb-0">
						<v-card-text class="grey--text pt-0 pl-0 pb-1">注意</v-card-text>
						<v-card-text class="grey--text pt-0 pl-0 pb-1">1. 数据开放接口区域必填</v-card-text>
						<v-card-text class="grey--text pt-0 pl-0 pb-1">2. 数据开放接口时间必填</v-card-text>
						<v-card-text class="grey--text pt-0 pl-0 pb-1">3. 授权确认后不能重新编辑</v-card-text>
					</v-card-title>
				</v-form>
			</v-card-text>
			<v-divider />
			<v-card-title class="pb-2 pt-2 pr-4">
				<v-spacer />
				<v-btn elevation="0" small text @click="close">取消</v-btn>
				<v-btn small text color="primary" @click="submit" elevation="0">确定</v-btn>
			</v-card-title>
		</v-card>
	</v-dialog>
</template>
<script>
// import Request from "@/commons/request";
// import Message from "../../components/message";
export default {
	data: () => ({
		user: {},
		dialog: false,
		valid: true,
		entity: {},
		menu: false,
		dates: [],
		areaArr: [],
		entData: null,
		AreaTree: [{ name: "", children: [] }], //数据开放接口区域树形数据
		AreaList: [], //所有地区数据
		stateJson: [],
	}),
	watch: {
		async active() {
			let res = {};
			if (this.active[0].areaCode == "0") {
				this.itemText = this.active[0].areaName;
			} else {
				res = await this.$vtk.request.getForm(`dict/area/show/${this.active[0].areaCode}`);
				this.itemText = [res.data.province, res.data.city, res.data.district, res.data.town, res.data.village].filter((item) => item).join("/");
			}
			this.$emit("input", this.active[0].areaCode);
		},
	},
	activated() {},
	methods: {
		// 授权
		edit(item) {
			this.user = this.$vtk.storage.get("_wit_acis_users");
			this.entData = item;
			this.entity.apis = item.id;
			this.entity.uniName = this.user.uniName;
			this.entity.uniCode = this.user.uniCode;
			this.stateJson = item.stateJson ? JSON.parse(item?.stateJson) : [];
			this.dialog = true;
		},
		timeSave() {
			if (this.dates.length > 1) {
				this.dates = this.dates.sort();
				this.entity.time = this.dates.join(" ~ ");
				this.entity.btime = this.dates[0];
				this.entity.etime = this.dates[1];
				this.$refs.menu.save(this.dates);
			} else {
				this.entity.time = "";
				this.$refs.menu.save(this.dates);
			}
		},
		// 授权提交
		submit() {
			this.entity.state = "0";
			this.entity.area = this.entity.areaCode.join();
			this.entity.acid = this.user.acid;
			this.stateJson.push({
				name: this.entity.stateJson?.length > 2 ? "修改申请" : "申请",
				state: "1",
				stateNote: this.entity.stateJson?.length > 2 ? "修改申请内容重新提交" : "第一次提交申请",
				operator: this.user.username,
				operateTime: this.$options.filters["date"](new Date(), "yyyy-MM-dd HH:mm:ss"),
			});
			this.entity.stateJson = JSON.stringify(this.stateJson);
			this.entity.operator = this.user.username;
			delete this.entity.areaCode;
			if (this.$refs.entity.validate()) {
				this.$vtk.request.postJson("/app/apis/save", this.entity).then((res) => {
					if (res.meta.success) {
						this.$emit("ok");
						this.$vtk.message.toast("保存成功", { color: " success " });
						this.close();
					} else {
						this.$vtk.message.toast(res.meta.message, { color: " error " });
					}
				});
			} else {
				this.$vtk.message.toast("基本信息中有信息未填写，请补充完整！", { color: " error " });
			}
		},
		close() {
			this.areaArr = [];
			this.dates = [];
			this.$refs?.entity?.reset();
			this.dialog = false;
		},
	},
};
</script>
<style lang="scss" scoped></style>
